module.exports = __webpack_public_path__ + "media/images/bar_graph-5f1d8de5fc46131946cffddf83ec42fece99800633f853da18be5366b56da179.svg";